module.exports = __webpack_public_path__ + "static/media/freshservice.9cbbff20.svg";